import PageNotFound from 'components/common/PageNotFound'
import HeadComponent from 'common/HeadComponent'

const Error404: React.FC = () => (
  <HeadComponent title="404, page not found">
    <PageNotFound />
  </HeadComponent>
)

export default Error404
